<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px" fill="currentColor">
        <!-- Photo frame (hollow via evenodd) -->
        <path fill-rule="evenodd" d="M2 4h20v16H2z M4 6h16v12H4z"/>
        <!-- Landscape inside -->
        <path d="M4 18L7 13L10.5 17L14 11L20 18Z"/>
        <!-- Sun -->
        <circle cx="8" cy="9" r="1.5"/>
        <!-- 4-point star badge (top-right, outside frame) -->
        <path d="M21 1L21.7 2.3L23 3L21.7 3.7L21 5L20.3 3.7L19 3L20.3 2.3Z"/>
    </svg>
</template>
